import React from 'react';
import { TableCellProps } from '@material-ui/core';
import { BaseTableCell } from './BaseTableCell';
import { SortIco } from './SortIco';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

export type TSortingDirection = 'asc' | 'desc' | '';

export interface ISort {
  orderBy: string;
  direction: TSortingDirection;
}

type PBaseTableHeaderCell = TableCellProps & {
  direction?: TSortingDirection;
  orderBy?: string;
  cellOrderBy?: string; // key of current cell for sorting
  onSort?: (params: ISort) => void;
};

const useStyles = makeStyles(() => ({
  cell: {
    display: 'flex',
    alignItems: 'center',
  },
  cell_pointer: {
    cursor: 'pointer',
  },
  sortIco: {
    marginLeft: '10px',
  },
}));

export const BaseTableHeaderCell: React.FC<PBaseTableHeaderCell> = (props) => {
  const {
    orderBy = '',
    cellOrderBy = '',
    children,
    onSort,
    direction = '',
    ...otherProps
  } = props;

  const classes = useStyles();
  const currentFieldSorting = orderBy === cellOrderBy;

  const handleClick = () => {
    if (onSort && cellOrderBy) {
      const isLastSortingVersion = currentFieldSorting && direction === 'desc';
      let newDirection: TSortingDirection = '';
      if (isLastSortingVersion) {
        newDirection = 'asc';
      } else if (!currentFieldSorting) {
        newDirection = 'asc';
      } else {
        newDirection = 'desc';
      }

      const nextSorting: ISort = {
        direction: newDirection,
        orderBy: isLastSortingVersion ? '' : cellOrderBy,
      };
      onSort(nextSorting);
    }
  };

  return (
    <BaseTableCell
      className={clsx(cellOrderBy && classes.cell_pointer)}
      {...otherProps}
    >
      <div className={classes.cell} onClick={handleClick}>
        {children}
        {cellOrderBy && (
          <SortIco
            className={clsx(classes.sortIco)}
            isActive={currentFieldSorting}
            direction={currentFieldSorting ? direction : 'asc'}
          />
        )}
      </div>
    </BaseTableCell>
  );
};
